import withNextApp from '@zurich-framework/nextapp/apphof';
import {
  NextAppBody,
  TranslationProvider,
} from '@zurich-framework/nextapp/components';
import type { SSRDefaultProps } from '@zurich-framework/nextapp/ssr';
import { RecoilRoot } from 'recoil';
import { RefsProvider } from '@zurich/common/contexts';
import { Dialogs } from '~/components/Dialogs/Dialogs';
import { Head } from '~/components/Head';
import { Layout } from '~/components/Layout';
import { createAppInstance } from '~/lib/appInstance';
import ErrorCustom from './error';

// we need to import css/fonts in the app boilerplate
import '@zurich/typography';
import '@zurich/icon-font';

const App = withNextApp(
  createAppInstance,
  ({ Component, context, i18n, pageProps, loading }) => {
    const { error } = context;

    return (
      <RecoilRoot>
        <TranslationProvider i18n={i18n}>
          <NextAppBody context={context}>
            <Head />
            <RefsProvider>
              <Layout
                disableSidebar={Component.displayName === 'SignIn'}
                loading={loading}
              >
                {error ? (
                  <ErrorCustom error={error} />
                ) : (
                  <>
                    <Component
                      {...(pageProps as SSRDefaultProps)} /* erase type as we practically pass anything to the page component */
                    />
                    <Dialogs />
                  </>
                )}
              </Layout>
            </RefsProvider>
          </NextAppBody>
        </TranslationProvider>
      </RecoilRoot>
    );
  }
);

export default App;
